import React from 'react';
import './loading.scss'
function BuyBeltError() {
  return (
    <div className="buybelt-error-wrapper">
        <div className="buybelt u__p-top--small"><span className="u__bold buybelt-title">How to Get It</span>
                <div className="u__p-top--small warning-message error-card notifyMe_border">
                    <div className="heading-message alert-inline--warning">
                    </div>
                    <div className="heading-message warning-body">
                        <span>
                            We're sorry, something went wrong on our end. Please try&nbsp;
                            <a href="#" className="u__default-link" onClick={()=>{window.location.reload(true);}}>refreshing</a>
                        </span>
                    </div>
                </div>
        </div>
    </div>
  );
}

export default BuyBeltError;
